import { Container, Row, Col, Button } from 'react-bootstrap'
import {FaShareAlt, FaFacebookF, FaTwitter, FaPinterestP, FaGooglePlusG, FaLinkedinIn } from "react-icons/fa";
import Link from 'next/link';
import { Request } from '@group-devs/yfp7-global-modules'
const request = new Request(process.env.apiDomain)

function ConfirmationSevenWays(props) {
	
    const url = process.env.backofficeDomain;

    const accountId = props.props.site.accountId;
    const { data: profile  } = request.account.swrAccountProfile(accountId)
    const user_id = profile ? parseInt(profile.user.id) : '';
    const url7ways = 'https://'+props.props.site.url

return (
    <>
    <div className="sevenWays__Confirmation">
        <Container>
            <Row>
                <Col lg={6} md={12} sm={12}>
                    <h1>Thank you!</h1>
                    <p className="my-4">Click on the DOWNLOAD button below to get my Free Report!</p>
                    <Link href={url + "website/ebook/mw?user_id="+user_id+"&download=true"}>
                        <Button variant="default mt-4 rounded-0"><i className="fas fa-download text-white mx-3"></i>DOWNLOAD THE FREE REPORT</Button>
                    </Link>
                        <p className="mt-5"><FaShareAlt className="text-white mr-3"/>Share this</p>
                    <Link href={"https://www.facebook.com/sharer/sharer.php?u="+url7ways}>
                        <a><FaFacebookF className="text-white border border-width-3 p-2 rounded-circle mx-2"/></a>
                </Link>
                    <Link href={"https://twitter.com/intent/tweet?url="+url7ways+"&text=7%20Ways%20to%20Improve%20your%20Memory"}>
                        <a><FaTwitter className="text-white border border-width-3 p-2 rounded-circle mx-2"/></a>
                </Link>
                    <Link href={"http://pinterest.com/pin/create/button/?url="+url7ways+"&media=&description=7%20Ways%20to%20Improve%20your%20Memory"}>
                        <a><FaPinterestP className="text-white border border-width-3 p-2 rounded-circle mx-2"/></a>
                </Link>
                    <Link href={"https://plus.google.com/share?url="+url7ways}>
                        <a><FaGooglePlusG className="text-white border border-width-3 p-2 rounded-circle mx-2"/></a>
                </Link>
                    <Link href={"http://www.linkedin.com/shareArticle?mini=true&url="+url7ways+"&title=7%20Ways%20to%20Improve%20your%20Memory"}>
                        <a><FaLinkedinIn className="text-white border border-width-3 p-2 rounded-circle mx-2"/></a>
                </Link>
                </Col>
            </Row>
        </Container>
    </div>
    <style jsx global>{`

        .sevenWays__Confirmation .btn{
            font-family: 'Bebas Neue', Helvetica, Arial, sans-serif;
            background: #FFB700;
            color: #034683;
            box-shadow: 0px 5px 0px #bf8a01;
            font-size: 2.5rem;
            font-weight: 500;
        }
            @media (max-width: 480px) {
                .sevenWays__Confirmation .btn{
                    font-size: 1.3rem;
                }

            }
        `}
    </style>
    <style jsx>{`
            .sevenWays__Confirmation{
                background: url(../images/7ways/bg-index-header01.jpg) no-repeat right -300px;
                padding: 80px 0px 300px;
                color: #FFF;
            }
            h1{
                color: #47bda8;
                font-size: 4.5rem;
            }
            a{
                font-size: 2.6rem;
            }
            
            @media (max-width: 480px) {
                h1{
                    font-size: 3rem;
                }

            }
            `}
        </style>
    </>
);
}
export default ConfirmationSevenWays;